export default "__VITE_ASSET__BBDT_OX0__"